import { render, staticRenderFns } from "./Turnstiles.vue?vue&type=template&id=0696f677&scoped=true"
import script from "./Turnstiles.vue?vue&type=script&lang=js"
export * from "./Turnstiles.vue?vue&type=script&lang=js"
import style0 from "./Turnstiles.vue?vue&type=style&index=0&id=0696f677&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0696f677",
  null
  
)

export default component.exports